import { render, staticRenderFns } from "./RoundStepRateNumbers.vue?vue&type=template&id=480a2b42&"
import script from "./RoundStepRateNumbers.vue?vue&type=script&lang=js&"
export * from "./RoundStepRateNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports